<template>
  <div>
    <b-row class="px-3 pb-5 px-sm-0 py-sm-5">
      <b-col cols="12" sm="4" class="text-center">
	<slot name="icon"></slot>
	<slot name="icon-title"></slot>
      </b-col>
      <b-col cols="12" sm="8" class="gmx-purple my-auto">
	<slot name="description-title"></slot>
	<slot name="description"></slot>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
    name: 'ConstructionBanner'
}
</script>


